import c from '../constants/Constants';
import $ from 'jquery';

require('es6-promise').polyfill();
require('isomorphic-fetch');


var cards = {

        getAll(filtros) {
            var esc = encodeURIComponent;
            var query = "";
            if (filtros)
                query = Object.keys(filtros)
                    .map(k => esc(k) + '=' + esc(filtros[k]))
                    .join('&');

            let defaultOptions = {
                url: '',
                method: 'GET',
                mode: 'cors',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Content-Type": "application/json;charset=UTF-8",
                    'idCuenta': window.location.pathname.split('/')[3],'idHerramienta': 6,
                },
                // cache: false,
                dataType: 'json',
            };
            if (!!localStorage.token) {
                defaultOptions.headers["Authorization"] = "Bearer " + localStorage.token;
            }
            return fetch(c.BASE_URL + '/cards/?' + query, defaultOptions);
        },
        getOne(idCard) {
            let defaultOptions = {
                url: '',
                method: 'GET',
                mode: 'cors',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Content-Type": "application/json;charset=UTF-8",
                    'idCuenta': window.location.pathname.split('/')[3],'idHerramienta': 6,
                },
                // cache: false,
                dataType: 'json',
            };
            if (!!localStorage.token) {
                defaultOptions.headers["Authorization"] = "Bearer " + localStorage.token;
            }
            return fetch(c.BASE_URL + '/cards/' + idCard, defaultOptions);
        },
        getFile(idCard, filtros) {
            var esc = encodeURIComponent;
            var query = "";
            if (filtros)
                query = Object.keys(filtros)
                    .map(k => esc(k) + '=' + esc(filtros[k]))
                    .join('&');
            let defaultOptions = {
                url: '',
                method: 'GET',
                mode: 'cors',
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    "Content-Type": "application/json;charset=UTF-8",
                    "pragma": "no-cache",
                    "cache-control": "no-cache",
                    'idCuenta': window.location.pathname.split('/')[3],'idHerramienta': 6,

                }
            };
            if (!!localStorage.token) {
                defaultOptions.headers["Authorization"] = "Bearer " + localStorage.token;
            }
            return fetch(c.BASE_URL + '/cards/' + idCard + '/file/?' + query, defaultOptions);
        },
        saveCreate(card) {
        let defaultOptions = {
            url: '',
            method: 'POST',
            mode: 'cors',
            headers: {
                'Access-Control-Allow-Origin': '*',
                "Content-Type": "application/json;charset=UTF-8",
                'idCuenta': window.location.pathname.split('/')[3],'idHerramienta': 6,
            },
            // cache: false,
            dataType: 'json',
            body: JSON.stringify(card)
        };
        if (!!localStorage.token) {
            defaultOptions.headers["Authorization"] = "Bearer " + localStorage.token;
        }

        return fetch(c.BASE_URL + '/cards/', defaultOptions);
    },
        saveUpdate(card) {
    let defaultOptions = {
        url: '',
        method: 'PUT',
        mode: 'cors',
        headers: {
            'Access-Control-Allow-Origin': '*',
            "Content-Type": "application/json;charset=UTF-8",
            'idCuenta': window.location.pathname.split('/')[3],'idHerramienta': 6,
        },
        // cache: false,
        dataType: 'json',
        body: JSON.stringify(card)
    };
    if (!!localStorage.token) {
        defaultOptions.headers["Authorization"] = "Bearer " + localStorage.token;
    }

    return fetch(c.BASE_URL + '/cards/' + card.id, defaultOptions);
},
          saveUpdateCards(activos) {
                 let defaultOptions = {
                     url: '',
                     method: 'PUT',
                     mode: 'cors',
                     headers: {
                         'Access-Control-Allow-Origin': '*',
                         "Content-Type": "application/json;charset=UTF-8",
                         "Authorization": "Bearer " + localStorage.token,
                         'idCuenta': window.location.pathname.split('/')[3],'idHerramienta': 6,
                     },
                     // cache: false,
                     dataType: 'json',
                     body: JSON.stringify(activos)
                 };
            if (!!localStorage.token) {
               defaultOptions.headers["Authorization"] = "Bearer " + localStorage.token;
            }
                 return fetch(c.BASE_URL + '/cards/all', defaultOptions);
             },
             saveDelete(card) {
                     let defaultOptions = {
                         url: '',
                         method: 'DELETE',
                         mode: 'cors',
                         headers: {
                             'Access-Control-Allow-Origin': '*',
                             "Content-Type": "application/json;charset=UTF-8",
                             "Authorization": "Bearer " + localStorage.token,
                             'idCuenta': window.location.pathname.split('/')[3],'idHerramienta': 6,
                         },
                         // cache: false,
                         dataType: 'json',
                     };
            if (!!localStorage.token) {
                defaultOptions.headers["Authorization"] = "Bearer " + localStorage.token;
            }
                     return fetch(c.BASE_URL + '/cards/' + card.id, defaultOptions);
                 },
         saveCreateCards(nuevos) {
              let defaultOptions = {
                  url: '',
                  method: 'POST',
                  mode: 'cors',
                  headers: {
                      'Access-Control-Allow-Origin': '*',
                      "Content-Type": "application/json;charset=UTF-8",
                      "Authorization": "Bearer " + localStorage.token,
                      'idCuenta': window.location.pathname.split('/')[3],'idHerramienta': 6,
                  },
                  // cache: false,
                  dataType: 'json',
                  body: JSON.stringify(nuevos)
              };
             if (!!localStorage.token) {
                defaultOptions.headers["Authorization"] = "Bearer " + localStorage.token;
             }
                  return fetch(c.BASE_URL + '/cards/all', defaultOptions);
              },
         printCard(idCard) {
                 let defaultOptions = {
                     url: '',
                     method: 'GET',
                     mode: 'cors',
                     headers: {
                         'Access-Control-Allow-Origin': '*',
                         "Content-Type": "multipart/form-data",
                         "Authorization": "Bearer " + localStorage.token,
                         'idCuenta': window.location.pathname.split('/')[3],'idHerramienta': 6,
                     },
                     cache: "no-cache"
                 };
                 return fetch(c.BASE_URL + '/cards/' + idCard + "/edit/", defaultOptions);
             },
    };

export default cards;